import { z } from 'zod';
import { getMutationSchema } from '../../../../../ui/util/getMutationSchema';
import { ResourceType } from '../../../../enumerations/ResourceType';
import {
    WorkflowRepresentationType,
    WorkflowRepresentationTypeSchema,
} from '../../../../enumerations/WorkflowRepresentationType';
import { useIndirectlyVersionedResourceAdapter } from '../../../../resource-base/adapters/useIndirectlyVersionedResourceAdapter';
import { useMultiResourceSingleParentedResourceAdapterActions } from '../../../../resource-base/adapters/useMultiResourceSingleParentedResourceAdapterActions';
import {
    defaultIndirectlyVersionedAndNamedArtifactResource,
    IndirectlyVersionedAndNamedArtifactResourceSchema,
} from '../../../../resource-base/artifactResourceTypes';

export enum WorkflowRepresentationPropertyValidation {
    NAME = 'NAME',
    TYPE = 'TYPE',
    DESCRIPTION = 'DESCRIPTION',
}

export const WorkflowRepresentationResourceSchema = IndirectlyVersionedAndNamedArtifactResourceSchema.extend({
    resourceType: z.literal(ResourceType.WORKFLOW_REPRESENTATION).default(ResourceType.WORKFLOW_REPRESENTATION),
    type: WorkflowRepresentationTypeSchema,
    description: z.string(),
});
export const WorkflowRepresentationMutationResourceSchema = getMutationSchema(WorkflowRepresentationResourceSchema);

export type WorkflowRepresentationResource = z.infer<typeof WorkflowRepresentationResourceSchema>;

export const defaultWorkflowRepresentationResource: WorkflowRepresentationResource = {
    ...defaultIndirectlyVersionedAndNamedArtifactResource,
    resourceType: ResourceType.WORKFLOW_REPRESENTATION,
    type: WorkflowRepresentationType.V_CYCLE,
    description: '',
};

export function useWorkflowRepresentationActions() {
    return {
        ...useMultiResourceSingleParentedResourceAdapterActions(
            'project/workflow-representation',
            ResourceType.WORKFLOW_REPRESENTATION,
            WorkflowRepresentationResourceSchema
        ),
        ...useIndirectlyVersionedResourceAdapter(
            'project/workflow-representation',
            ResourceType.WORKFLOW_REPRESENTATION,
            WorkflowRepresentationResourceSchema
        ),
    };
}
